import { Grid, Typography } from '@mui/material';
import { PageWrapper } from 'components/page-wrapper/PageWrapper';
import React, { Children } from 'react';
import {
    ContractsReceiptWrapperProps,
    DisplayItem,
    LabelAndCodeContainer,
    LabelAndValueContainer,
    viewReceiptsStyles,
} from './contracts-receipt-wrapper-helper';

export const ContractsReceiptWrapper = ({
    chain,
    breadCrumType,
    onBackArrowClick,
    informationDisplayItems,
    headerDisplayItems,
}: ContractsReceiptWrapperProps): React.JSX.Element => {
    return (
        <PageWrapper
            title={'Receipt'}
            includeBreadcrumbs={true}
            breadCrumStatus='update'
            breadCrumType={breadCrumType}
            breadCrumData={chain}
            readOnly={true}
            onBackArrowClick={onBackArrowClick}
        >
            <Grid sx={viewReceiptsStyles.mainContainerStyles}>
                <Grid sx={viewReceiptsStyles.informationTextContainer}>
                    <Typography sx={viewReceiptsStyles.headingTextStyles}>
                        Information
                    </Typography>
                </Grid>
                <Grid sx={viewReceiptsStyles.infoContainerStyles}>
                    {Children.toArray(
                        informationDisplayItems.map((item: DisplayItem) => {
                            if (item.isCode) {
                                return (
                                    <LabelAndCodeContainer
                                        label={item.label}
                                        code={item.value}
                                    />
                                );
                            }
                            return (
                                <LabelAndValueContainer
                                    label={item.label}
                                    value={item.value}
                                />
                            );
                        })
                    )}
                </Grid>
                <Grid sx={viewReceiptsStyles.headerTextContainer}>
                    <Typography sx={viewReceiptsStyles.headingTextStyles}>
                        Header
                    </Typography>
                </Grid>
                <Grid sx={viewReceiptsStyles.headerContainerStyles}>
                    {Children.toArray(
                        headerDisplayItems.map((item: DisplayItem) => {
                            return (
                                <LabelAndValueContainer
                                    label={item.label}
                                    value={item.value}
                                />
                            );
                        })
                    )}
                </Grid>
            </Grid>
        </PageWrapper>
    );
};
